module.exports = __webpack_public_path__ + "img/shiba888-ic-mobile-left-1.53d2e7e5.png";